import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import CmoLeadershipEventComponent from '../components/CmoLeadershipEventComponent'
import BreadcrumCmoLeadershipSummit from '../components/BreadcrumbCmoLeadershipSummit'
import CmoSummitEventSection from '../components/CmoSummitEvevntSection'

export default function CmoLeadershipSummit2026() {
  return (
    <div>
      <Header1/>
      <BreadcrumCmoLeadershipSummit/>
      <CmoLeadershipEventComponent/>
      <CmoSummitEventSection/>
      <Footer/>
    </div>
  )
}
